@if (!isLoading()) {
  <div
    class="product-preview pt-tiny px-tiny pb-medium radius-big d-flex flex-column justify-content-start align-items-center cursor-pointer gap-small {{
      classes()
    }}"
    (click)="handleClick()"
    [ngClass]="{ 'surface-elevated': backgroundMode() === 'elevated', 'surface-back': backgroundMode() !== 'elevated' }"
  >
    @if (product().title) {
      <div
        class="product-preview-imagebox radius-plus d-flex align-items-center justify-content-center w-100"
        [ngClass]="{ 'surface-elevated': backgroundMode() !== 'elevated', 'surface-back': backgroundMode() === 'elevated' }"
      >
        @if (offPercent()) {
          <div class="product-preview-imagebox-off">
            <ngx-badge
              [mode]="'bold'"
              [status]="'error'"
              [size]="'sm'"
              [template]="percentbox"
            ></ngx-badge>
          </div>
          <ng-template #percentbox>
            <span class="ltr">{{ offPercent() }}</span>
          </ng-template>
        }
        <img
          class="product-preview-imagebox-img"
          src="{{ productImageSrc() }}"
          alt="{{ product().title | stripTags | cleaner | summarize: titleLimit() }}"
          (error)="handleImageError()"
        />
        @if (product().storeLogoImageId) {
          <div
            class="product-preview-store-imgbox d-flex align-items-center justify-content-center surface-glass-high-contrast radius-rounded"
          >
            <ui-api-image
              [width]="'18px'"
              [imageId]="product().storeLogoImageId ?? ''"
              [fallbackImage]="'assets/fallback/digipay-logo-32x32-fallback.svg'"
            ></ui-api-image>
          </div>
        }
      </div>
    }
    <div class="flex-grow d-flex flex-column justify-content-space-between w-100">
      @if (product().title || product().storeName) {
        <div>
          @if (product().storeName) {
            <div class="product-preview-store d-flex align-items-center justify-content-start spacing-micro w-100 px-minus mb-tiny">
              <div class="l-2 text-onback-medium">{{ product().storeName }}</div>
            </div>
          }
          @if (product().title) {
            <div class="product-preview-title c-2 text-onback-high w-100 px-minus">
              {{ product().title | stripTags | cleaner | summarize: titleLimit() }}
            </div>
          }
          @if (hasPaymentMethods()) {
            <div class="mt-small d-flex align-items-center justify-content-start gap-low px-minus">
              @for (paymentMethod of paymentMethods(); track $index) {
                <div class="d-flex align-items-center justify-content-start gap-micro">
                  <common-icon-dp-icon
                    [classes]="'text-onback-disabled'"
                    [icon]="paymentMethod.icon"
                    [iconSize]="'16'"
                    [iconType]="'linear'"
                  ></common-icon-dp-icon>
                  <span class="l-2 text-onback-low">{{ paymentMethod.name }}</span>
                </div>
                @if ($index < paymentMethods().length - 1) {
                  <div
                    class="border-l-300 border-color-tint"
                    [style.height]="'12px'"
                  ></div>
                }
              }
            </div>
          }
        </div>
      }
      @if (previousPrice() > 0 || product().price) {
        <div class="product-preview-pricebox d-flex flex-column align-items-start justify-content-center gap-atom w-100 px-minus">
          @if (previousPrice() > 0) {
            <div class="product-preview-pricebox-previous l-2 text-onback-low mt-minus">{{ previousPrice() | thousands }}</div>
          }
          @if (product().price) {
            <div class="d-flex align-items-center justify-content-start gap-micro">
              <div class="product-preview-pricebox-new st-8 text-onback-high">{{ product().price | thousands }}</div>
              <div class="bt-2 text-onback-low">{{ priceUnit() }}</div>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <lib-ngx-skeleton-loading
    [height]="'264px'"
    [classes]="'radius-plus mb-minus'"
  ></lib-ngx-skeleton-loading>
}
